import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

type ClockIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const ClockIcon = ({
  title = 'Clock',
  viewBox = '0 0 16 16',
  ...props
}: ClockIconProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <path fillOpacity=".01" d="M0 0h16v16H0z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8a8 8 0 1116 0A8 8 0 010 8zm14.345 0a6.345 6.345 0 10-12.69 0 6.345 6.345 0 0012.69 0z"
    />
    <path
      stroke="currentColor"
      strokeWidth="1.333"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 4.001v4.666M8.017 8.708l2.357-2.357"
    />
  </CreateIconComponent>
);

export default ClockIcon;
